import { getCurrentCountry } from './country';
import { getPathname } from './dom';
var DefaultCulture = 'en-IE';
function resolveBelgiumCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/fr') ||
        pathnameInLowerCase.startsWith('/fr-be')) {
        return 'fr-BE';
    }
    return 'nl-BE';
}
function resolveAmericanCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/es')) {
        return 'es-US';
    }
    return 'en-US';
}
function resolveCanadianCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/fr')) {
        return 'fr-CA';
    }
    return 'en-CA';
}
function resolveSwissCulture(pathname) {
    var pathnameInLowerCase = pathname.toLowerCase();
    if (pathnameInLowerCase.startsWith('/fr')) {
        return 'fr-CH';
    }
    if (pathnameInLowerCase.startsWith('/it')) {
        return 'it-CH';
    }
    return 'de-CH';
}
export var getCurrentCulture = function () {
    var country = getCurrentCountry();
    var pathname = getPathname();
    switch (country.toUpperCase()) {
        case 'PT':
            return 'pt-PT';
        case 'IE':
            return 'en-IE';
        case 'ES':
            return 'es-ES';
        case 'IN':
            return 'en-IN';
        case 'US':
            return resolveAmericanCulture(pathname);
        case 'GB':
            return 'en-GB';
        case 'FR':
            return 'fr-FR';
        case 'IT':
            return 'it-IT';
        case 'DE':
            return 'de-DE';
        case 'NL':
            return 'nl-NL';
        case 'DK':
            return 'da-DK';
        case 'SE':
            return 'sv-SE';
        case 'AT':
            return 'de-AT';
        case 'NO':
            return 'nb-NO';
        case 'FI':
            return 'fi-FI';
        case 'BE':
            return resolveBelgiumCulture(pathname);
        case 'SG':
            return 'en-SG';
        case 'JP':
            return 'ja-JP';
        case 'NZ':
            return 'en-NZ';
        case 'AU':
            return 'en-AU';
        case 'CA':
            return resolveCanadianCulture(pathname);
        case 'CH':
            return resolveSwissCulture(pathname);
        default:
            return DefaultCulture;
    }
};
//# sourceMappingURL=data:application/json;base64,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